<template>
  <b-sidebar
    id="sidebar-create-district"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ district.id ? $t('Update District') : 'Create District' }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <!-- Uz Name -->
        <b-form-group
          :label="$t('name uz')"
          label-for="uz-name"
        >
          <b-form-input
            id="uz-name"
            v-model="district.name.uz"
            trim
          />
        </b-form-group>

        <!-- Ru Name -->
        <b-form-group
          :label="$t('name ru')"
          label-for="ru-name"
        >
          <b-form-input
            id="ru-name"
            v-model="district.name.ru"
            trim
          />
        </b-form-group>

        <!-- En Name -->
        <b-form-group
          :label="$t('name en')"
          label-for="en-name"
        >
          <b-form-input
            id="en-name"
            v-model="district.name.en"
            trim
          />
        </b-form-group>

        <!-- Category Subject Id -->
        <b-form-group
          :label="$t('Region')"
          label-for="region"
        >
          <v-select
            id="country"
            v-model="district.region"
            :reduce="(option) => option.id"
            :options="regions"
            :get-option-label="(option) => option.name[$i18n.locale]"
          />
        </b-form-group>
        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="submit(hide)"
          >
            {{ district.id ? $t('Update District') : $t('Create District') }}
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="clear(hide)"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  computed: {
    regions() {
      return this.$store.state.region.regions
    },
    district: {
      get() {
        return this.$store.state.district.district
      },
      set(data) {
        this.$store.commit('district/UPDATE', data)
      },
    },
  },
  methods: {
    clear(hide) {
      this.$store.commit('district/FRESH')
      hide()
    },
    submit(hide) {
      this.$createSwal(this, this.district, `district/${this.district.id ? 'update' : 'create'}`, () => {
        this.$emit('refetchData')
        this.$store.commit('district/FRESH')
      })
      hide()
    },
  },
}
</script>
